export class HeaderSearchForm {
	constructor(element) {
		if (!element) return;

		this.element = element;
		this.input = this.element?.querySelector('.header-search-form__input');

		this.init();
	}

	clickHandler = ({ target }) => {
		if (target.closest('.header-search-form__reset')) {
			this.input.value = '';
			this.input.dispatchEvent(new CustomEvent('input'));
			this.input.dispatchEvent(new CustomEvent('change'));
		}
	};

	init = () => {
		this.element.addEventListener('click', this.clickHandler);
	};
}
